import { render } from "./income-table.vue?vue&type=template&id=650a053f"
import script from "./income-table.vue?vue&type=script&lang=js"
export * from "./income-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__